export enum Side {
    Ally = "ally", 
    Enemy = "enemy",
};

export interface Position {
    col: number;
    row: number;
}